"use strict";

require("core-js/modules/es6.object.assign");

var _slicedToArray = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

require("core-js/modules/es6.object.define-property");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var react_intersection_observer_1 = require("react-intersection-observer");

var imageAddStrategy = function imageAddStrategy(_ref) {
  var lazyLoad = _ref.lazyLoad,
      isSsr = _ref.isSsr,
      isIntersectionObserverAvailable = _ref.isIntersectionObserverAvailable,
      inView = _ref.inView,
      loaded = _ref.loaded;

  if (!lazyLoad) {
    return true;
  }

  if (isSsr) {
    return false;
  }

  if (isIntersectionObserverAvailable) {
    return inView || loaded;
  }

  return true;
};

var imageShowStrategy = function imageShowStrategy(_ref2) {
  var lazyLoad = _ref2.lazyLoad,
      isSsr = _ref2.isSsr,
      isIntersectionObserverAvailable = _ref2.isIntersectionObserverAvailable,
      loaded = _ref2.loaded;

  if (!lazyLoad) {
    return true;
  }

  if (isSsr) {
    return false;
  }

  if (isIntersectionObserverAvailable) {
    return loaded;
  }

  return true;
};

exports.Image = function (_ref3) {
  var className = _ref3.className,
      fadeInDuration = _ref3.fadeInDuration,
      intersectionTreshold = _ref3.intersectionTreshold,
      intersectionMargin = _ref3.intersectionMargin,
      pictureClassName = _ref3.pictureClassName,
      _ref3$lazyLoad = _ref3.lazyLoad,
      lazyLoad = _ref3$lazyLoad === void 0 ? true : _ref3$lazyLoad,
      style = _ref3.style,
      pictureStyle = _ref3.pictureStyle,
      explicitWidth = _ref3.explicitWidth,
      data = _ref3.data;

  var _react_1$useState = react_1.useState(false),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      loaded = _react_1$useState2[0],
      setLoaded = _react_1$useState2[1];

  var handleLoad = react_1.useCallback(function () {
    setLoaded(true);
  }, []);

  var _react_intersection_o = react_intersection_observer_1.useInView({
    threshold: intersectionTreshold || 0,
    rootMargin: intersectionMargin || "0px 0px 0px 0px",
    triggerOnce: true
  }),
      _react_intersection_o2 = _slicedToArray(_react_intersection_o, 3),
      ref = _react_intersection_o2[0],
      inView = _react_intersection_o2[1],
      _entry = _react_intersection_o2[2];

  var isSsr = typeof window === "undefined";
  var isIntersectionObserverAvailable = isSsr ? false : !!window.IntersectionObserver;
  var absolutePositioning = {
    position: "absolute",
    left: 0,
    top: 0,
    bottom: 0,
    right: 0
  };
  var addImage = imageAddStrategy({
    lazyLoad: lazyLoad,
    isSsr: isSsr,
    isIntersectionObserverAvailable: isIntersectionObserverAvailable,
    inView: inView,
    loaded: loaded
  });
  var showImage = imageShowStrategy({
    lazyLoad: lazyLoad,
    isSsr: isSsr,
    isIntersectionObserverAvailable: isIntersectionObserverAvailable,
    inView: inView,
    loaded: loaded
  });
  var webpSource = data.webpSrcSet && react_1["default"].createElement("source", {
    srcSet: data.webpSrcSet,
    sizes: data.sizes,
    type: "image/webp"
  });
  var regularSource = data.srcSet && react_1["default"].createElement("source", {
    srcSet: data.srcSet,
    sizes: data.sizes
  });
  var placeholder = react_1["default"].createElement("div", {
    style: Object.assign({
      backgroundImage: data.base64 ? "url(".concat(data.base64, ")") : null,
      backgroundColor: data.bgColor,
      backgroundSize: "cover",
      opacity: showImage ? 0 : 1,
      transition: !fadeInDuration || fadeInDuration > 0 ? "opacity ".concat(fadeInDuration || 500, "ms ").concat(fadeInDuration || 500, "ms") : null
    }, absolutePositioning)
  });
  var width = data.width,
      aspectRatio = data.aspectRatio;
  var height = data.height || width / aspectRatio;
  var sizer = react_1["default"].createElement("svg", {
    className: pictureClassName,
    style: Object.assign({
      width: explicitWidth ? "".concat(width, "px") : "100%",
      height: "auto",
      display: "block"
    }, pictureStyle),
    height: height,
    width: width
  });
  return react_1["default"].createElement("div", {
    ref: ref,
    className: className,
    style: Object.assign(Object.assign({
      display: "inline-block",
      overflow: "hidden"
    }, style), {
      position: "relative"
    })
  }, sizer, placeholder, addImage && react_1["default"].createElement("picture", {
    style: Object.assign(Object.assign({}, absolutePositioning), {
      opacity: showImage ? 1 : 0,
      transition: !fadeInDuration || fadeInDuration > 0 ? "opacity ".concat(fadeInDuration || 500, "ms") : null
    })
  }, webpSource, regularSource, data.src && react_1["default"].createElement("img", {
    src: data.src,
    alt: data.alt,
    title: data.title,
    onLoad: handleLoad,
    style: {
      width: "100%"
    }
  })), react_1["default"].createElement("noscript", null, react_1["default"].createElement("picture", {
    className: pictureClassName,
    style: Object.assign({}, pictureStyle)
  }, webpSource, regularSource, data.src && react_1["default"].createElement("img", {
    src: data.src,
    alt: data.alt,
    title: data.title
  }))));
};